import React, { useState, useContext } from "react";
import {
  IconButton,
  Stack,
  Box,
  Tooltip,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
//Icons
import { MdDelete, MdModeEdit } from "react-icons/md";
//Srcs
import "../../Style/actionstyle.scss";
import DeleteSchoolFee from "./DeleteSchoolFee";
import UpdateSchoolFee from "./UpdateSchoolFee";
import { AuthContext } from "../../Context/AuthContext";
import { translateLauguage } from "../../Function/Translate";
import MoreVertIcon from "@mui/icons-material/MoreVert";
export default function SchoolFeeAction({ editData, setRefetch }) {
  // Change Language
  const { language } = useContext(AuthContext);
  const { t } = translateLauguage(language);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);
  console.log("editData====>", editData);
  return (
    <div>
      <Stack direction="row">
        <IconButton
          sx={{ padding: "3px" }}
          id="demo-positioned-button"
          aria-controls={open ? "demo-positioned-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
        >
          <MoreVertIcon fontSize="medium" />
        </IconButton>
      </Stack>

      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        {/* <MenuItem
          onClick={() => {
            handleClose();
            handleOpenEdit();
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1.4}>
            <Stack
              className="update-container"
              alignItems="center"
              justifyContent="center"
              paddingTop="3px"
            >
              <MdModeEdit className="update-icon" />
            </Stack>
            <Typography>Update</Typography>
          </Stack>
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            handleClose();
            handleOpenDel();
          }}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <MdDelete className="delete-icon" />
            <Typography>Delete</Typography>
          </Stack>
        </MenuItem>
      </Menu>
      {/* <Stack direction="row" justifyContent="right">
        <Tooltip title={t("modal_title_update_role")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton> 
        </Tooltip>
        <Tooltip title={t("modal_title_delete_SchoolFee")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack> */}

      {/* <UpdateSchoolFee
        open={openEdit}
        handleClose={handleCloseEdit}
        editData={editData}
        setRefetch={setRefetch}
      /> */}
      <DeleteSchoolFee
        open={openDel}
        handleClose={handleCloseDel}
        editData={editData}
        setRefetch={setRefetch}
      />
    </div>
  );
}
